export default __webpack_public_path__ + "partner_15fd9188.png";